import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Button, Glyphicon } from "react-bootstrap";

class Save extends Component {
  render() {
    const { stores } = this.props;
    return (
      <Button bsStyle="primary" {...this.props}>
        <Glyphicon glyph="save" /> {stores.ui.translate.Save}
      </Button>
    );
  }
}

export default inject("stores")(observer(Save));



// WEBPACK FOOTER //
// ./src/Core/Components/Buttons/Save.js